<template>
  <div>
    <div class="yto-box" style="padding-bottom: 10px;">
      <el-form class="templateForm" :inline="true" :model="form" ref="ruleForm" label-width="70px">        
        <el-form-item label="模板名称" prop="templateName">
          <!-- <el-autocomplete
            v-model="form.templateName"
            clearable
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入模板名称"
          >
          <template slot-scope="{ item }">
            <div class="name y-f-ell" :title="item.value">{{ item.value }}</div>
          </template>
          </el-autocomplete> -->
          <el-input style="width: 260px" v-model="form.templateName" placeholder="请输入模板名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="快递公司" prop="cpCode">
          <el-select v-model="form.cpCode" placeholder="请选择" clearable>
            <el-option
              v-for="item in companyCodeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="btn-r" label="" >
          <el-button icon="el-icon-search" type="primary" @click="queryTemplateList">查询</el-button>
          <el-button class="normal-btn" @click="resetForm"><i class="el-icon-refresh-left y-fc-4C84FF"></i>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="yto-table y-pd-20">
      <div class="y-mb-20">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="isShowTpl=true">添加电子面单模板</el-button>
      </div>
      <el-table :data="tableData">
        <el-table-column label="模板样式" min-width="100" align="center">
          <template slot-scope="scope">
            <div class="y-p-r pre-box">
              <el-image
                style="width: auto;height: 70px;"
                v-if="defaultTemplateType.includes(scope.row.baseTempId)"
                :src="require(`@/assets/images/${scope.row.baseTempId}.png`)"
                :preview-src-list="[require(`@/assets/images/${scope.row.baseTempId}.png`)]">
              </el-image>
              <el-image
                v-else
                style="width: auto;height: 70px;"
                :src="require('@/assets/images/88880001.png')"
                :preview-src-list="[require('@/assets/images/88880001.png')]">
              </el-image>
            </div>
            <div class="y-fw-700">{{scope.row.templateType}}</div>
          </template>
        </el-table-column>
        <el-table-column label="模板名称" min-width="140">
          <template slot-scope="scope">
            <div>{{ scope.row.tempName }}</div>
            <div>尺寸：{{ scope.row.curTemplatSize }}</div>
          </template>
        </el-table-column>
        <!-- 电子面单信息 -->
        <el-table-column label="电子面单信息" min-width="230">
          <template slot-scope="scope">
            <div v-if="scope.row.printAccount != 'KTHJ999999' && scope.row.waybillCode != 'THJ'">
              <div v-if="scope.row.waybillCode === 'YTO' || scope.row.waybillCode === 'YTO_ZD'" class="y-f y-f-jb">
                <div v-if="scope.row.printAccount">
                  <div>账号：{{ scope.row.printAccount }}</div>
                  <div>网点名称：{{ scope.row.printAccountName }}</div>
                  <div class="y-w-115 y-fc-4C84FF y-c-p" @click="showOriginDialog(scope.row)"><i class="el-icon-edit"></i>修改电子面单账号</div>
                </div>
                <div class="y-w-115 y-fc-4C84FF y-c-p" v-else @click="showOriginDialog(scope.row)"><i class="el-icon-circle-plus-outline"></i>添加电子面单账号</div>
              </div>
              <div v-else class="y-f y-f-jb">
                <div v-if="scope.row.addressInfoList || scope.row.printAccount">
                  <div>账号：{{ scope.row.mallName || '' }}</div>
                  <div>网点名称：{{ scope.row.printAccountName || ''}}</div>
                  <div>网点发货地址：{{ scope.row.addressInfo || ''}}</div>
                  <!-- 是物不查面单余额 -->
                  <div v-if="bindDataList[scope.row.id] && scope.row.waybillCode != 'DEWU'">
                    余额：
                    <span v-if="bindDataList[scope.row.id].isRefreshAvailable && !cpCodeList.includes(scope.row.wpCode)">
                      <i v-if="bindDataList[scope.row.id].apiLoading" class="el-icon-loading"></i>
                      <span class="y-fc-F56C6C" v-else-if="bindDataList[scope.row.id].isUnAuthed">账号失效，请重新绑定</span>
                      <span v-else class="y-fc-4C84FF y-ml-5 y-c-p" @click="getRemainingSum(scope.row, scope.row.id, true)">点击重试</span>
                    </span>
                    <span
                      :class="{
                        'y-fc-F32F52': bindDataList[scope.row.id].remainingSum <= 100,
                        'y-fc-3bb950': bindDataList[scope.row.id].remainingSum > 100
                      }"
                      v-else-if="!cpCodeList.includes(scope.row.wpCode)">
                      {{ bindDataList[scope.row.id].remainingSum }}
                    </span>
                    <span v-else>-</span>
                  </div>
                  <div class="y-w-115 y-fc-4C84FF y-c-p" @click="showOriginDialog(scope.row)"><i class="el-icon-edit"></i>修改电子面单账号</div>
                </div>
                <div class="y-w-115 y-fc-4C84FF y-c-p" v-else @click="showOriginDialog(scope.row)"><i class="el-icon-circle-plus-outline"></i>添加电子面单账号</div>
              </div>
            </div>
            <div v-else-if="scope.row.waybillCode != 'THJ'">
              <div>账号：{{ scope.row.printAccount }}</div>
            </div>
          </template>
        </el-table-column>
        <!-- 默认发货地址 -->
        <el-table-column min-width="180">
          <template slot="header">
            默认发货地址
            <el-tooltip class="item" effect="light" placement="top-start">
              <span slot="content">
                <span>为模板设置默认发货地址时，该模板默认发货地址即为此处设置的发货地址，而不是系统发货地址中设置的默认地址</span>
              </span>
              <i class="el-icon-question y-fc-4C84FF y-c-p"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope" v-if="bindDataList && bindDataList[scope.row.id]&&scope.row.printAccount != 'KTHJ999999' && scope.row.waybillCode != 'THJ'">
            <div v-html="senderListMap[bindDataList[scope.row.id].sendAddressId]"></div>
            <div class="y-w-115 y-fc-4C84FF y-c-p" @click="handleSetDefaultAddress(scope.row, scope.row.id)"><i class="el-icon-edit"></i>设置默认发货地址</div>
          </template>
        </el-table-column>
        <!-- 打印机 -->
        <el-table-column label="打印机" min-width="140">
          <template slot-scope="scope" v-if="bindDataList && bindDataList[scope.row.id]&&scope.row.printAccount != 'KTHJ999999'">
            <el-select
              size="mini"
              v-model="bindDataList[scope.row.id].printerName"
              :loading="bindDataList[scope.row.id].printerLoading"
              @focus="handleFocus(scope.row, scope.row.id)"
              @change="(val) => handleChangePrint(val, scope.row)"
              placeholder="请选择打印机">
              <el-option
                v-for="(item, index) in bindDataList[scope.row.id].printerList"
                :key="index"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- 店铺默认模板 -->
        <el-table-column min-width="150">
          <template slot="header">
            店铺默认模板
            <el-tooltip class="item" effect="light" placement="top-start">
              <span slot="content">
                <span>为店铺设置默认模板，当在运单打印模块切换到该店铺时，电子面单模板将自动切换。</span>
              </span>
              <i class="el-icon-question y-fc-4C84FF y-c-p"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope" v-if="scope.row.printAccount != 'KTHJ999999' && scope.row.waybillCode != 'THJ'">
            <div class="shoplist" v-if="scope.row.mallEntityList">
              <span v-for="item in scope.row.mallEntityList" :key="item.mallId">
                <svg-icon v-if="PLATFORMICONMAP[item.paltformCode]" class="icon" :icon-class="PLATFORMICONMAP[item.paltformCode]"></svg-icon>{{ item.mallName }}
              </span>
            </div>
            <div class="y-w-115 y-pl-5 y-fc-4C84FF y-c-p" v-if="scope.row.mallEntityList && scope.row.mallEntityList.length" @click="handleAddShopSetting(scope.row)"><i class="el-icon-edit"></i>修改店铺默认模板</div>
            <div class="y-w-115 y-pl-5 y-fc-4C84FF y-c-p" v-else @click="handleAddShopSetting(scope.row)"><i class="el-icon-circle-plus-outline"></i>添加店铺默认模板</div>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column label="操作" min-width="80">
          <template slot-scope="scope">
            <div class="y-f y-f-fc y-f-as">
              <el-link class="y-fs-12" :underline="false" type="primary" @click="customTemplate(scope.row)">自定义模板</el-link>
              <el-link class="y-fs-12" :underline="false" type="danger" @click="deleteTemplate(scope.row)">删除</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="fixed-paginton-footer box-shadow-wrapper">
        <el-pagination
          @size-change="limitChange"
          @current-change="pageChange"
          :current-page.sync="page.pageNo"
          :page-sizes="[10, 50, 100]"
          :page-size="page.limit"
          layout="total, sizes, prev, pager, next"
          :total="page.total">
        </el-pagination>
      </div>
      <el-dialog center :title="printerTipTitle" :visible.sync="visible" :close-on-press-escape="false" :close-on-click-modal="false">
        <el-alert type="warning" show-icon :closable="false">
          <template v-if="curTplWaybillCode === 'PDD'">
            <p class="y-fs-14">请先启动拼多多打印组件后重试。</p>
            <p class="y-fs-14">如您未安装，请点击<a class="systemColor" href="https://meta.pinduoduo.com/api/one/app/v1/lateststable?appId=com.xunmeng.pddprint&platform=windows&subType=main">下载安装</a>，安装成功后，启动组件重新获取打印机信息</p>
          </template>
          <template v-else-if="curTplWaybillCode === 'LUBAN'">
            <p class="y-fs-14">请先启动抖音打印组件后重试。</p>
            <p class="y-fs-14">如您未安装，请点击<a class="systemColor" href="https://logistics.douyinec.com/davinci/CloudPrintClient">下载安装</a>，安装成功后，启动组件重新获取打印机信息</p>
          </template>
          <template v-else-if="curTplWaybillCode === 'KS'">
            <p class="y-fs-14">请先启动快手打印组件后重试。</p>
            <p class="y-fs-14">如您未安装，请点击<a class="systemColor" href="https://cloudprint.kwaixiaodian.com/rest/pc/scm/ebill/print/installer/download">下载安装</a>，安装成功后，启动组件重新获取打印机信息</p>
          </template>
          <template v-else-if="curTplWaybillCode === 'JD'">
            <p class="y-fs-14">请先启动京东打印组件后重试。</p>
            <p class="y-fs-14">如您未安装，请点击<a class="systemColor" href="https://prod-oms-app-cprt.jdwl.com/OpenCloudPrint/setup.exe">下载安装</a>，安装成功后，启动组件重新获取打印机信息</p>
          </template>
          <template v-else-if="curTplWaybillCode === 'WXSPH'">
            <p class="y-fs-14">请先启动腾讯打印组件后重试。</p>
            <p class="y-fs-14">如您未安装，请点击<a class="systemColor" href="https://res.wx.qq.com/shop/print/ChannelsShopPrintClient-setup.exe">下载安装</a>，安装成功后，启动组件重新获取打印机信息</p>
          </template>
          <template v-else-if="curTplWaybillCode === 'WXGYS'">
            <p class="y-fs-14">请先启动腾讯打印组件后重试。</p>
            <p class="y-fs-14">如您未安装，请点击<a class="systemColor" href="https://res.wx.qq.com/shop/print/ChannelsShopPrintClient-setup.exe">下载安装</a>，安装成功后，启动组件重新获取打印机信息</p>
          </template>
          <template v-else-if="curTplWaybillCode === 'XIAOHS'">
            <p class="y-fs-14">请先启动小红书新打印组件后重试。</p>
            <p class="y-fs-14">如您未安装，请点击<a class="systemColor" href="https://xhswaybill-printer-1251524319.cos.ap-shanghai.myqcloud.com/XHSPrintClient/prod/windows/xhs-electron-printer_x64-setup.exe">下载安装</a>，安装成功后，启动组件重新获取打印机信息</p>
          </template>
          <template v-else-if="curTplWaybillCode === 'DEWU'">
            <p class="y-fs-14">请先启动得物新打印组件后重试。</p>
            <p class="y-fs-14">如您未安装，请点击<a class="systemColor" href="https://h5static.dewu.com/print-app/client/win/%E5%BE%97%E7%89%A9%E6%89%93%E5%8D%B0%20Setup.exe">下载安装</a>，安装成功后，启动组件重新获取打印机信息</p>
          </template>
          <template v-else>
            <p class="y-fs-14">请先启动菜鸟打印组件后重试。</p>
            <p class="y-fs-14">如您未安装，请点击<a class="systemColor" href="https://cainiao-oss-sh-read.oss-cn-shanghai.aliyuncs.com/waybill-print/cainiao-x-print/prod/win/cainiao-x-print-win-86.exe?spm=a219a.7386653.0.0.214c669aAlb85m&file=cainiao-x-print-win-86.exe">下载安装</a>，安装成功后，启动组件重新获取打印机信息</p>
          </template>
        </el-alert>
        <div slot="footer">
          <el-button type="primary" class="y-w-100" @click="visible = false">知道了</el-button>
        </div>
      </el-dialog>
      <el-dialog custom-class="add-address-dialog" center :visible.sync="addAddressDialog" :show-close="false">
        <div class="y-fl-32">如您已成功创建发货人地址，请点击确定按钮后，再次点击选择发货地址下拉项进行选择。</div>
        <div class="y-fl-32">如您想进行其他操作，请点击取消按钮。</div>
        <div slot="footer">
          <el-button class="y-w-100" @click="addAddressDialog = false">取消</el-button>
          <el-button type="primary" class="y-w-100" @click="refresh">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 设置默认单号来源 -->
    <set-default-template-origin
      v-if="isShowOrigin"
      :isShow="isShowOrigin"
      pageType="DYALL"
      :waybillOrigin="waybillOrigin"
      @closeOriginForm="closeOriginForm"
    ></set-default-template-origin>
    <!-- 添加电子面单模板 -->
    <add-face-tpl
      :tplList="tableData"
      :visible.sync="isShowTpl"
      v-if="isShowTpl"
      @showShopSetting="showShopSettingFromFaceTpl"
      :close-by-confirm="getUserPrintTempList">
    </add-face-tpl>
    <!-- 添加/编辑店铺默认模板 -->
    <addShopDefaultTpl 
      :curRowInfo="curRowInfo"
      :visible.sync="isShowShopSetting"
      v-if="isShowShopSetting"
      :close-by-confirm="getUserPrintTempList"
     />
    <!-- 收件人发件人弹窗 -->
    <selectAddressDialog
      :hideAddBtn="true"
      @handleSelected="handleSelected"
      :show.sync="showDialog"
      type="sender"
    />
  </div>
</template>
<script>
import cnPrint from '@/utils/cainiaoPrint';
import pddPrint from '@/utils/pddPrint';
import dyPrint from '@/utils/douyinPrint';
import jdPrint from '@/utils/jingdongPrint';
import ksPrint from '@/utils/kuaishouPrint';
import xhsNewPrint from '@/utils/xhsPrintNew';
import wxPrint from '@/utils/wxPrint';
import dwPrint from '@/utils/dewuPrint';
import util from '@/utils/util';
import { getCaiNiaoGrantTokenApi } from '@/api/customerCode';
import { aliBillSearchApi, getCaiNiaoExpressListApi, getCustomerAddressApi, getCustomerUserPrintTempListApi, lubanNetsiteApi, queryPddWaybillListApi, updatePrintTplApi, wayBillISearchApi } from '@/api/universal';
import { lubanDFShopListApi, mallCodeWayBillKsApi, mallCodeWayBillLubanApi, pddMallCodeWayBillApi, xiaohsMallCodeWayBillApi, xiaohsWaybillBalanceApi, yzBalanceListApi, yzMallCodeWayBillApi, mallCodeWayBillDewuApi } from '@/api/baseInfo/shopManage/storeManagement';
import { ksWaybillBalanceApi } from '@/api/waybillPrint/ksPrint';
import { jdWaybillBalanceApi, jdWaybillCodeAuthorizeApi } from '@/api/waybillPrint/jdPrint';
import { batchExpressBindApi, delUserCustomPrintTplApi, dydfMallCodeWayBillApi  } from '@/api/baseInfo/printTemplate/eleFaceSheetTpl';
import { PLATFORMICONMAP } from '@/utils/globalConfig';
import { wxNetsiteApi } from '@/api/baseInfo/printSetting/electronicFaceAccount';
export default {
  name: 'waybillTemplate',
  components: {
    'set-default-template-origin': () => import('@/components/printValidate/setDefaultTemplateOrigin.vue'),
    addFaceTpl: () => import('./components/addFaceTpl.vue'),
    addShopDefaultTpl: () => import('./components/addShopDefaultTpl.vue'),
    selectAddressDialog: () => import('@/views/printingPage/customPrintNewReconsitution/components/selectAddressDialog.vue')
  },
  data() {
    return {
      showDialog: false, // 设置默认发件人弹窗
      tableData: [], // 表格源数据
      defaultTemplateType: [...util.oneWaybillList, ...util.twoWaybillList, ...util.threeWaybillList, ...util.dygfWaybillList, ...util.ksgfWaybillList, ...util.wxWaybillList], // 所有模板类型
      dyksgfWaybillList: [...util.dygfWaybillList, ...util.ksgfWaybillList, ...util.xiaohsWaybillList, ...util.wxWaybillList], // 抖音&快手官方官方模板
      bindDataList: [], // 绑定发货人地址和打印机
      senderList: [], // 发件人地址
      senderListMap: {}, // 发件人地址映射，方便判断保存的地址是否被删除
      isShowOrigin: false,
      waybillOrigin: null,
      dyPrinterList: [],  // 抖音打印机列表
      ksPrinterList: [],  // 快手打印机列表
      dyAlertTitle: null, // 抖店打印组件的提示，为''则正常启用
      ksAlertTitle: null, // 快手打印组件的提示，为''则正常启用
      wxAlertTitle: null, // 腾讯打印组件的提示，为''则正常启用
      pddTitle: null, // 拼多多打印组件的提示，为 '' 则正常启用
      cnTitle: null, // 菜鸟打印组件的提示，为''则正常启用
      jdTitle: null, // 京东打印组件的提示，为''则正常启用
      xhsTitle: null, // 小红书打印组件的提示，为''则正常启用
      xhsTitleNew: null, // 小红书新打印组件的提示，为''则正常启用
      dwAlertTitle: null, // 得物打印组件的提示，为''则正常启用
      printerTipTitle: '', // 未安装打印组件的title
      warningTitle: '',
      visible: false,
      curTplWaybillCode: '', // 当前模板类型
      isShowTpl: false, // 是否显示添加弹窗
      threeTempType: util.threeWaybillList, // 三联单模板类型
      addAddressDialog: false, // 添加地址后的提示弹窗
      cpCodeList: ['SF', 'EMS', 'YZKDBG'], // 这几个快递公司不显示余额
      isShowShopSetting: false, // 设置店铺默认模板的弹窗显隐标记
      curRowInfo: null, // 当前模板的信息
      PLATFORMICONMAP,
      curRowInfo: null, // 当前选中行信息
      curRowIdx: 0, // 当前选中行下标
      companyCodeList: [
        {name: '圆通速递', code: 'YTO'},
        {name: '中通速递', code: 'ZTO'},
        {name: '韵达快递', code: 'YUNDA'},
        {name: '顺丰速运', code: 'SF'},
        {name: '申通快递', code: 'STO'},
        {name: '百世快递', code: 'BEST'},
        {name: '邮政快递包裹', code: 'YZKDBG'},        
        {name: 'EMS', code: 'EMS'},
        {name: '京东物流', code: 'JD'},
        {name: '极兔速递', code: 'JT'},
        {name: '其他', code: 'other'}
      ],
      form: {
        templateName: '',
        cpCode: ''
      },
      page: {
        limit: 10,
        pageNo: 1,
        total: 0
      },
      allTableList: [],
      allTableListBak: [],
      timeout: null
    };
  },
  methods: {
    querySearchAsync(queryString, cb) {
      let restaurants = this.allTableListBak.map(o => { return {value: o.tempName}});
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 50);
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
      };
    },
    limitChange(limt) {
      this.page.pageNo = 1;
      this.page.limit = limt;
      this.splitTalbeData();
    },
    pageChange(pageNo) {
      this.page.pageNo = pageNo;
      this.splitTalbeData();
    },
    splitTalbeData() {
      // 根据查询条件过滤数据
      let formName = this.form.templateName.trim();
      if (formName || this.form.cpCode) {
        let filterArr = [];
        if (formName && this.form.cpCode) {
          filterArr = this.allTableListBak.filter(o => { return (o.tempName.indexOf(formName) > -1 && o.wpCode == this.form.cpCode) })
        } else if (formName) {
          filterArr = this.allTableListBak.filter(o => { return o.tempName.indexOf(formName) > -1 })
        } else if (this.form.cpCode) {
          filterArr = this.allTableListBak.filter(o => { return o.wpCode == this.form.cpCode })
        }
        this.allTableList = JSON.parse(JSON.stringify(filterArr));
        this.page.total = this.allTableList.length;
        if (this.page.total / this.page.limit < this.page.pageNo) {
          this.page.pageNo = 1;
        }
      } else {
        this.allTableList = JSON.parse(JSON.stringify(this.allTableListBak));
        this.page.total = this.allTableList.length;
      }
      console.log('this.allTableList', this.allTableList)
      // 数据截取
      let startIndex = (this.page.pageNo - 1) * this.page.limit;
      let endIndex = startIndex + this.page.limit;
      let result = this.allTableList.slice(startIndex, endIndex);
      // 手动分页完成后，只处理当前页数据的信息
      for(let i = 0; i < result.length; i++) {
        if (result[i].addressInfoList && result[i].addressInfoList.length) {
          let address = result[i].addressInfoList[0] || {};
          result[i].addressInfo = `${address.province||''}${address.city||''}${address.district||''}${result[i].waybillCode == 'XIAOHS' ? (address.town || '') : ''}${address.detail||''}`;
        }
        result[i].curTemplatSize = result[i].templateSize && result[i].templateSize.replace('宽', '').replace('高', '').replace(/：/g, '').replace(',', ' *') || '';

        // 如果地址列表没有之前保存的地址id了 就置为undefined
        if(!this.senderListMap[result[i].defaultSendAddress]) result[i].defaultSendAddress = undefined;
        this.bindDataList[`${result[i].id}`] = {
          sendAddressId: result[i].defaultSendAddress,
          printerName: result[i].defaultPrint,
          printerList: [], // 打印机列表
          printerLoading: false, // 打印机是否正在获取
          remainingSum: undefined,
          isRefreshAvailable: true,
          apiLoading: true
        } 
        if(result[i].addressInfoList || result[i].printAccount) {
          // 绑定了面单账号才去调接口
          setTimeout(() => {
            this.getRemainingSum(result[i], result[i].id);
          }, i);
        }
      }
      this.tableData = result;
    },
    // 查询按钮
    queryTemplateList() {
      this.pageChange(1);
    },
    resetForm() {
      this.form.templateName = '';
      this.form.cpCode = '';
      this.page.pageNo = 1;
      this.getUserPrintTempList();
    },
    handleSetDefaultAddress(row, idx) {
      if (util.yzdWaybillList.includes(row.baseTempId)) {
        this.$confirm('圆通标准面单已支持使用圆准达服务，打印时可以选择圆通标准模板', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          return false;
        });
      } else {
        // 设置默认发货地址
        this.showDialog = true;
        this.curRowInfo = JSON.parse(JSON.stringify(row));
        this.curRowIdx = idx;
      }
    },
    handleSelected(item) {
      // 设置默认发件人地址
      const params = {
        ...this.curRowInfo,
        defaultSendAddress: item.id
      }
      updatePrintTplApi(params).then(() => {
        this.$message.success('默认发货地址设置成功');
        this.$set(this.bindDataList[this.curRowInfo.id], 'sendAddressId', item.id);
        this.tableData = [...this.tableData];
        // 备份的数据也要同步更新，前端分页需要用到备份数据
        this.allTableList.forEach(row => {
          if (row.id == this.curRowInfo.id) {
            row.defaultSendAddress = item.id;
          }
        })
        this.allTableListBak.forEach(row => {
          if (row.id == this.curRowInfo.id) {
            row.defaultSendAddress = item.id;
          }
        })
      })
    },
    showShopSettingFromFaceTpl(val) {
      // 添加电子面单模板拉起设置默认店铺弹窗
      this.curRowInfo = JSON.parse(val); // 这里单独处理一下tempId
      this.isShowShopSetting = true;
    },
    // 添加店铺默认模板
    handleAddShopSetting(row) {
      this.curRowInfo = JSON.parse(JSON.stringify(row)); // 当前行的信息
      this.isShowShopSetting = true;
    },
    getUserPrintTempList() {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      this.bindDataList = {};
      getCustomerUserPrintTempListApi({loginId: this.userMess.loginId, waybillCode: 'LUBAN'}).then(res => {
        if (res.message === 'ok') {
          if (res.data && res.data.length) {
            this.tableData = [];
            let result = res.data || [];
            this.allTableList = JSON.parse(JSON.stringify(result));
            this.allTableListBak = JSON.parse(JSON.stringify(result));
            this.page.total = result.length;
            this.splitTalbeData();
            // 建立初始数据
            // 防止数据太多，分批进行渲染
            // let rowCount = result.length;
            // let chunkSize = rowCount < 10 ? rowCount : 10;
            // let divideInto = parseInt(rowCount / chunkSize);
            // let remainder = rowCount % chunkSize;
            // let iteration = 0;
            // let generateRows;
            // setTimeout(generateRows = () => {
            //   // 计算上次中断的地方
            //   let base = chunkSize * iteration;
            //   // 数据较多 按10条数据分批时，有剩余不满10条的情况
            //   if(base === rowCount - remainder && chunkSize !== rowCount && iteration == divideInto) {
            //     chunkSize = remainder;
            //   }
            //   for(let i = 0; i < chunkSize; i++) {
            //     if (result[i + base].addressInfoList && result[i + base].addressInfoList.length) {
            //       let address = result[i + base].addressInfoList[0] || {};
            //       result[i + base].addressInfo = `${address.province||''}${address.city||''}${address.district||''}${result[i + base].waybillCode == 'XIAOHS' ? (address.town || '') : ''}${address.detail||''}`;
            //     }
            //     result[i + base].curTemplatSize = result[i + base].templateSize && result[i + base].templateSize.replace('宽', '').replace('高', '').replace(/：/g, '').replace(',', ' *') || '';
            //     this.tableData.push(result[i + base]);

            //     // 如果地址列表没有之前保存的地址id了 就置为undefined
            //     if(!this.senderListMap[result[i + base].defaultSendAddress]) result[i + base].defaultSendAddress = undefined;
            //     this.bindDataList.push({
            //       sendAddressId: result[i + base].defaultSendAddress,
            //       printerName: result[i + base].defaultPrint,
            //       printerList: [], // 打印机列表
            //       printerLoading: false, // 打印机是否正在获取
            //       remainingSum: undefined,
            //       isRefreshAvailable: true,
            //       apiLoading: true
            //     })
            //     if(result[i + base].addressInfoList || result[i + base].printAccount) {
            //       // 绑定了面单账号才去调接口
            //       setTimeout(() => {
            //         this.getRemainingSum(result[i + base], i + base);
            //       }, i + base);
            //     }
            //   }
            //   iteration++;
            //   // 调度下一个阶段
            //   if((iteration < divideInto && remainder == 0) || (iteration <= divideInto && remainder != 0)) {
            //     setTimeout(generateRows, 10)
            //   }
            // }, 0)
          } else {
            this.tableData = [];
          }
          this.dataLoading = false;
        } else {
          this.tableData = [];
          this.$message.error(res.error);
        }
        loadingMask.close();
      }).catch(err => {
        this.tableData = [];
        this.$message.error(err.error);
        loadingMask.close();
      });
    },
    // 查询余额
    getRemainingSum(row, i, isSingle) {
      /**
       * 1. 面单账号不能区分平台？
       * 2. 拼多多面单模板 店铺ID 需要确认下 接口里面的mallId是个啥？
       * 3. 接口里面没有branchCode字段？
       */
      if(row.platformTypeOfWayBill === 'PDD') {
        this.queryWaybillApplyBalanceList(row, i, isSingle);
      }else if(row.platformTypeOfWayBill === 'CN') {
        this.getCaiNiaoExpressList(row, i, isSingle);
      }else if(row.platformTypeOfWayBill === 'TAOBAO'){
        this.wayBillISearch(row, i, isSingle);
      } else if(row.platformTypeOfWayBill === 'ALI_1688') {
        this.aliBillISearch(row, i, isSingle);
      }else if(row.platformTypeOfWayBill === 'LUBAN'){
        this.listShopNetsite(row, i, isSingle);
      }else if(row.platformTypeOfWayBill === 'DYDF'){
        this.lubanDFShopList(row, i, isSingle);
      }else if(row.platformTypeOfWayBill === 'JD'){
        this.jdShopList(row, i, isSingle);
      }else if(row.platformTypeOfWayBill === 'KS'){
        this.ksShopList(row, i, isSingle);
      }else if(row.platformTypeOfWayBill === 'XIAOHS'){
        this.xiaohsShopList(row, i, isSingle);
      }else if(row.platformTypeOfWayBill === 'YZ'){
        this.yzShopList(row, i, isSingle);
      } else if(row.platformTypeOfWayBill === 'WXSPH') {
        this.wxShopList(row, i, isSingle);
      } else if(row.platformTypeOfWayBill === 'WXGYS') {
        this.wxgysShopList(row, i, isSingle);
      }
    },
    // 查询拼多多物流公司和面单余额列表
    queryWaybillApplyBalanceList(row, i, isSingle) {
      let params = {
        mallId: row.printAccount, // 店铺ID 需要确认下 接口里面的mallId是个啥？
        mallName: row.mallName, // 店铺名称
        waybillCode: 'PDD', // 面单类型
        cpCode: row.wpCode, // 物流公司平台
        branchCode: row.branchCodeOfWayBill // 接口里面没有这个字段
      };
      this.bindDataList[i].apiLoading = true;
      queryPddWaybillListApi(params).then(res => {
        if (res.message === 'ok') {
          let list = res.data || [];
          let oList = list.filter(item => { return item.branchCode === row.branchCodeOfWayBill; });
          let available = oList.length ? (oList[0].quantity || 0) : 0;
          this.bindDataList[i].remainingSum = available;
          this.bindDataList[i].isRefreshAvailable = false;
        } else {
          if(isSingle) {
            // 如果是单挑查询，则提示错误
            if(res.data) {
              this.$message.error(`${res.error||''}_${res.data||''}`);
            } else {
              this.$message.error('查询失败，网络错误，请稍候重试');
            }
          }
          if(res.errorCode == 24) {
            // 店铺授权过期
            this.$set(this.bindDataList[i], 'isUnAuthed', true);
          } else {
            this.$set(this.bindDataList[i], 'isUnAuthed', false);
          }
          this.bindDataList[i].isRefreshAvailable = true;
        }
      }).catch(err => {
        if(isSingle) {
          // 如果是单挑查询，则提示错误
          this.$message.error(`${err.error||''}_${err.data||''}` || '查询失败');
        }
        this.bindDataList[i].isRefreshAvailable = true;
      }).finally(() => {
        this.bindDataList[i].apiLoading = false;
        this.bindDataList = {...this.bindDataList};
      });
    },
    // 查询菜鸟物流公司和面单余额列表
    getCaiNiaoExpressList(row, i, s) {
      let params = {
        waybillCode: 'CN',
        mallId: row.printAccount,
        branchCode: row.branchCodeOfWayBill
      };
      this.bindDataList[i].apiLoading = true;
      getCaiNiaoExpressListApi(params).then(res => {
        if (res.message === 'ok') {
          let list = res.data || [];
          let available = list.length ? (list[0].quantity || 0) : 0;
          this.$set(this.bindDataList[i], 'remainingSum', available);
          this.$set(this.bindDataList[i], 'isRefreshAvailable', false);
        } else {
          if (s) {
            if(res.data) {
              this.$message.error(`${res.error||''}_${res.data||''}`);
            } else {
              this.$message.error('查询失败，网络错误，请稍候重试');
            }
          }
          if(res.errorCode == 24) {
            // 店铺授权过期
            this.$set(this.bindDataList[i], 'isUnAuthed', true);
          } else {
            this.$set(this.bindDataList[i], 'isUnAuthed', false);
          }
          this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
        }
      }).catch((err) => {
        if (s) {
          this.$message.error(`${err.error||''}_${err.data||''}` || '查询失败，网络错误，请稍候重试');
        }
        this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
      }).finally(() => {
        this.bindDataList[i].apiLoading = false;
        this.bindDataList = {...this.bindDataList};
      });
    },
    // 1688余额查询
    aliBillISearch(row, i, s) {
      let params = {
        mallCode:row.mallCode,
        cpCode:row.wpCode,
        branchCode:row.branchCodeOfWayBill,
        platformCode: 'ALI_1688',
      }
      this.bindDataList[i].apiLoading = true;
      aliBillSearchApi(params).then(res => {
        if (res.message === 'ok') {
          let list = res.data || [];
          let available = list.length ? (list[0].quantity || 0) : 0;
          this.$set(this.bindDataList[i], 'remainingSum', available);
          this.$set(this.bindDataList[i], 'isRefreshAvailable', false);
        } else {
          if (s) {
            if(res.data) {
              this.$message.error(`${res.error||''}_${res.data||''}`);
            } else {
              this.$message.error('查询失败，网络错误，请稍候重试');
            }
          }
          if(res.errorCode == 24) {
            // 店铺授权过期
            this.$set(this.bindDataList[i], 'isUnAuthed', true);
          } else {
            this.$set(this.bindDataList[i], 'isUnAuthed', false);
          }
          this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
        }
      }).catch((err) => {
        if (s) {
          this.$message.error(`${err.error||''}_${err.data||''}` || '查询失败，网络错误，请稍候重试');
        }
        this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
      }).finally(() => {
        this.bindDataList[i].apiLoading = false;
        this.bindDataList = {...this.bindDataList};
      });
    },
    // 淘宝余额查询
    wayBillISearch(row, i, s) {
      let params = {
        mallCode: row.mallCode,
        cpCode: row.wpCode,
        branchCode: row.branchCodeOfWayBill,
      }
      this.bindDataList[i].apiLoading = true;
      wayBillISearchApi(params).then(res => {
        if (res.code === 1) {
          let list = res.data || [];
          let available = list.length ? (list[0].quantity || 0) : 0;
          this.$set(this.bindDataList[i], 'remainingSum', available);
          this.$set(this.bindDataList[i], 'isRefreshAvailable', false);
        } else {
          if (s) {
            if(res.data) {
              this.$message.error(`${res.error||''}_${res.data||''}`);
            } else {
              this.$message.error('查询失败，网络错误，请稍候重试');
            }
          }
          if(res.errorCode == 24) {
            // 店铺授权过期
            this.$set(this.bindDataList[i], 'isUnAuthed', true);
          } else {
            this.$set(this.bindDataList[i], 'isUnAuthed', false);
          }
          this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
        }
      }).catch((err) => {
        if (s) {
          this.$message.error(`${err.error||''}_${err.data||''}` || '查询失败，网络错误，请稍候重试');
        }
        this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
      }).finally(() => {
        this.bindDataList[i].apiLoading = false;
        this.bindDataList = {...this.bindDataList};
      });
    },
    // 鲁班查询余额
    listShopNetsite(row, i, s) {
      let params = {
        logisticsCode: util.logisticsObj[row.wpCode],
        mallId: row.printAccount
      };
      this.bindDataList[i].apiLoading = true;
      lubanNetsiteApi(params).then(res => {
        if (res.message === 'ok') {
          let list = res.data.netsites || [];
          let oList = list.filter(item => { return item.netsite_code === row.branchCodeOfWayBill; });
          let available = oList.length ? (oList[0].amount || 0) : 0;
          this.$set(this.bindDataList[i], 'remainingSum', available);
          this.$set(this.bindDataList[i], 'isRefreshAvailable', false);
        } else {
          if (s) {
            if(res.data) {
              this.$message.error(`${res.error||''}_${res.data||''}`);
            } else {
              this.$message.error('查询失败，网络错误，请稍候重试');
            }
          }
          if(res.errorCode == 24) {
            // 店铺授权过期
            this.$set(this.bindDataList[i], 'isUnAuthed', true);
          } else {
            this.$set(this.bindDataList[i], 'isUnAuthed', false);
          }
          this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
        }
      }).catch((err) => {
        if (s) {
          this.$message.error(`${err.error||''}_${err.data||''}` || '查询失败，网络错误，请稍候重试');
        }
        this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
      }).finally(() => {
        this.bindDataList[i].apiLoading = false;

        this.bindDataList = {...this.bindDataList};
      });
    },
    // 厂商查询余额
    lubanDFShopList(row, i, s) {
      let params = {
        logisticsCode: util.logisticsObj[row.wpCode],
        mallId: row.printAccount
      };
      this.bindDataList[i].apiLoading = true;
      lubanDFShopListApi(params).then(res => {
        if (res.message === 'ok') {
          let list = res.data.netsites || [];
          let oList = list.filter(item => { return item.netsite_code === row.branchCodeOfWayBill; });
          let available = oList.length ? (oList[0].amount || 0) : 0;
          this.$set(this.bindDataList[i], 'remainingSum', available);
          this.$set(this.bindDataList[i], 'isRefreshAvailable', false);
        } else {
          if (s) {
            if(res.data) {
              this.$message.error(`${res.error||''}_${res.data||''}`);
            } else {
              this.$message.error('查询失败，网络错误，请稍候重试');
            }
          }
          if(res.errorCode == 24) {
            // 店铺授权过期
            this.$set(this.bindDataList[i], 'isUnAuthed', true);
          } else {
            this.$set(this.bindDataList[i], 'isUnAuthed', false);
          }
          this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
        }
      }).catch((err) => {
        if (s) {
          this.$message.error(`${err.error||''}_${err.data||''}` || '查询失败，网络错误，请稍候重试');
        }
        this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
      }).finally(() => {
        this.bindDataList[i].apiLoading = false;
        this.bindDataList = {...this.bindDataList};
      });
    },
    // 京东查询余额
    jdShopList(row, i, s) {
      let params = {
        cpCode: row.wpCode,
        mallId: row.mallId || '',
        mallCode: row.mallCode || ''
      };
      this.bindDataList[i].apiLoading = true;
      this.$set(this.bindDataList[i], 'remainingSum', 0);
      jdWaybillBalanceApi(params).then(res => {
        if (res.message === 'ok') {
          let list = res.data || [];
          let oList = list.filter(item => { return item.branchCode === row.branchCodeOfWayBill; });
          let available = oList.length ? (oList[0].quantity || 0) : 0;
          this.$set(this.bindDataList[i], 'remainingSum', available);
          this.$set(this.bindDataList[i], 'isRefreshAvailable', false);
        } else {
          if (s) {
            if(res.data) {
              this.$message.error(`${res.error||''}_${res.data||''}`);
            } else {
              this.$message.error('查询失败，网络错误，请稍候重试');
            }
          }
          if(res.errorCode == 24) {
            // 店铺授权过期
            this.$set(this.bindDataList[i], 'isUnAuthed', true);
          } else {
            this.$set(this.bindDataList[i], 'isUnAuthed', false);
          }
          this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
        }
      }).catch(() => {
        if (s) {
          this.$message.error('查询失败，网络错误，请稍候重试');
        }
        this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
      }).finally(() => {
        this.bindDataList[i].apiLoading = false;
        this.bindDataList = {...this.bindDataList};
      });
    },
    // 快手查询余额
    ksShopList(row, i, s) {
      let params = {
        cpCode: row.wpCode,
        mallId: row.mallId || '',
        mallCode: row.mallCode || ''
      };
      this.bindDataList[i].apiLoading = true;
      this.$set(this.bindDataList[i], 'remainingSum', 0);
      ksWaybillBalanceApi(params).then(res => {
        if (res.code === 1) {
          let list = res.data || [];
          let oList = list.filter(item => { return item.branchCode === row.branchCodeOfWayBill || item.netSiteCode === row.branchCodeOfWayBill; });
          let available = oList.length ? (oList[0].availableQuantity || 0) : 0;
          this.$set(this.bindDataList[i], 'remainingSum', available);
          this.$set(this.bindDataList[i], 'isRefreshAvailable', false);
        } else {
          if (s) {
            if(res.data) {
              this.$message.error(`${res.error||''}_${res.data||''}`);
            } else {
              this.$message.error('查询失败，网络错误，请稍候重试');
            }
          }
          if(res.errorCode == 24) {
            // 店铺授权过期
            this.$set(this.bindDataList[i], 'isUnAuthed', true);
          } else {
            this.$set(this.bindDataList[i], 'isUnAuthed', false);
          }
          this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
        }
      }).catch((err) => {
        if (s) {
          this.$message.error('查询失败，网络错误，请稍候重试');
        }
        this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
      }).finally(() => {
        this.bindDataList[i].apiLoading = false;
        this.bindDataList = {...this.bindDataList};
      });
    },
    // 小红书查询余额
    xiaohsShopList(row, i, s) {
      let params = {
        cpCode: row.cpCode,
        mallId: row.mallId,
        branchCode: row.branchCode,
        platformCode: 'XIAOHS',
      };
      this.bindDataList[i].apiLoading = true;
      this.$set(this.bindDataList[i], 'remainingSum', 0);
      xiaohsWaybillBalanceApi(params).then(res => {
        if (res.code === 1) {
          let list = res.data || [];
          let oList = list.filter(item => { return (item.branchCode === row.branchCodeOfWayBill || item.netSiteCode === row.branchCodeOfWayBill); });
          let available = oList.length ? (oList[0].usage.quantity || 0) : 0;
          this.$set(this.bindDataList[i], 'remainingSum', available);
          this.$set(this.bindDataList[i], 'isRefreshAvailable', false);
        } else {
          if (s) {
            if(res.data) {
              this.$message.error(`${res.error||''}_${res.data||''}`);
            } else {
              this.$message.error('查询失败，网络错误，请稍候重试');
            }
          }
          if(res.errorCode == 24) {
            // 店铺授权过期
            this.$set(this.bindDataList[i], 'isUnAuthed', true);
          } else {
            this.$set(this.bindDataList[i], 'isUnAuthed', false);
          }
          this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
        }
      }).catch((err) => {
        if (s) {
          this.$message.error('查询失败，网络错误，请稍候重试');
        }
        this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
      }).finally(() => {
        this.bindDataList[i].apiLoading = false;
        this.bindDataList = {...this.bindDataList};
      });
    },
    // 有赞余额查询
    yzShopList(row, i, s) {
      let params = {
        cpCode: row.cpCode,
        mallId: row.mallId,
        branchCode: row.branchCode,
        platformCode: 'YZ',
      };
      this.bindDataList[i].apiLoading = true;
      this.$set(this.bindDataList[i], 'remainingSum', 0);
      yzBalanceListApi(params).then(res => {
        if (res.code === 200) {
          let list = res.data || [];
          let oList = list.filter(item => { return item.branchCode === row.branchCodeOfWayBill || item.netSiteCode === row.branchCodeOfWayBill; });
          let available = oList.length ? (oList[0].usage.quantity || 0) : 0;
          this.$set(this.bindDataList[i], 'remainingSum', available);
          this.$set(this.bindDataList[i], 'isRefreshAvailable', false);
        } else {
          if (s) {
            if(res.data) {
              this.$message.error(`${res.error||''}_${res.data||''}`);
            } else {
              this.$message.error('查询失败，网络错误，请稍候重试');
            }
          }
          if(res.errorCode == 24) {
            // 店铺授权过期
            this.$set(this.bindDataList[i], 'isUnAuthed', true);
          } else {
            this.$set(this.bindDataList[i], 'isUnAuthed', false);
          }
          this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
        }
      }).catch((err) => {
        if (s) {
          this.$message.error('查询失败，网络错误，请稍候重试');
        }
        this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
      }).finally(() => {
        this.bindDataList[i].apiLoading = false;
        this.bindDataList = {...this.bindDataList};
      });
    },
    // 腾讯电子面单查询余额
    wxShopList(row, i, s) {
      let params = {
        logisticsCode: row.wpCode,
        mallId: row.mallId
      };
      this.bindDataList[i].apiLoading = true;
      this.$set(this.bindDataList[i], 'remainingSum', 0);
      wxNetsiteApi(params).then(res => {
        if (res.code === 1) {
          let list = res.data.account_list || [];
          let oList = list.filter(item => item.site_info && item.site_info.site_code === row.branchCodeOfWayBill);
          let available = oList.length ? (oList[0].available || 0) : 0;
          this.$set(this.bindDataList[i], 'remainingSum', available);
          this.$set(this.bindDataList[i], 'isRefreshAvailable', false);
        } else {
          if (s) {
            if(res.data) {
              this.$message.error(`${res.error||''}_${res.data||''}`);
            } else {
              this.$message.error('查询失败，网络错误，请稍候重试');
            }
          }
          if(res.errorCode == 24) {
            // 店铺授权过期
            this.$set(this.bindDataList[i], 'isUnAuthed', true);
          } else {
            this.$set(this.bindDataList[i], 'isUnAuthed', false);
          }
          this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
        }
      }).catch((err) => {
        if (s) {
          this.$message.error('查询失败，网络错误，请稍候重试');
        }
        this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
      }).finally(() => {
        this.bindDataList[i].apiLoading = false;
        this.bindDataList = {...this.bindDataList};
      });
    },
    // 微信供货商电子面单查询余额
    wxgysShopList(row, i, s) {
      let params = {
        logisticsCode: row.wpCode,
        mallId: row.mallId,
        platformType: 'WXGYS'
      };
      this.bindDataList[i].apiLoading = true;
      this.$set(this.bindDataList[i], 'remainingSum', 0);
      wxNetsiteApi(params).then(res => {
        if (res.code === 1) {
          let list = res.data.account_list || [];
          let oList = list.filter(item => item.site_info && item.site_info.site_code === row.branchCodeOfWayBill);
          let available = oList.length ? (oList[0].available || 0) : 0;
          this.$set(this.bindDataList[i], 'remainingSum', available);
          this.$set(this.bindDataList[i], 'isRefreshAvailable', false);
        } else {
          if (s) {
            if(res.data) {
              this.$message.error(`${res.error||''}_${res.data||''}`);
            } else {
              this.$message.error('查询失败，网络错误，请稍候重试');
            }
          }
          if(res.errorCode == 24) {
            // 店铺授权过期
            this.$set(this.bindDataList[i], 'isUnAuthed', true);
          } else {
            this.$set(this.bindDataList[i], 'isUnAuthed', false);
          }
          this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
        }
      }).catch((err) => {
        if (s) {
          this.$message.error('查询失败，网络错误，请稍候重试');
        }
        this.$set(this.bindDataList[i], 'isRefreshAvailable', true);
      }).finally(() => {
        this.bindDataList[i].apiLoading = false;
        this.bindDataList = {...this.bindDataList};
      });
    },
    // 获取发件人地址
    getSendAddressList(isInit) {
      const params = {
        isSend: true,
        pageNo: 1,
        limit: 100000, // 假装100000条就是全部了
        remarks: ''
      }

      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      getCustomerAddressApi(params).then(res => {
        // mounted的时候才这样调用
        if(isInit) this.getUserPrintTempList();
        this.senderListMap = {};
        this.senderList = res.data.list;
        this.senderList.forEach(item => {
          this.senderListMap[item.id] = '<span style="font-weight: bold;">' + item.name + '</span>' + (item.mobile ? '</br>' + item.mobile : '') + (item.phone ? '</br>' + item.phone : '') + '</br>'  + (item.provinceName?item.provinceName:'') +  (item.cityName?item.cityName:'') +  (item.districtName?item.districtName:'') +'</br>' + item.address;
        })
        loadingMask.close();
      }).catch(() => {
        loadingMask.close();
      })
    },
    // 显示模板来源弹层
    showOriginDialog(row) {
      if (util.yzdWaybillList.includes(row.baseTempId)) {
        this.$confirm('圆通标准面单已支持使用圆准达服务，打印时可以选择圆通标准模板', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          return false;
        });
      } else {
        this.waybillOrigin = JSON.parse(JSON.stringify(row));
        this.isShowOrigin = true;
      }
    },
    // 关闭单号来源弹层
    closeOriginForm(flag) {
      this.isShowOrigin = false;
      this.waybillOrigin = null;
      if (flag === 'refresh') {
        this.getUserPrintTempList();
      }
    },
    async handleFocus(row, idx) {
      this.curTplWaybillCode = row.waybillCode;
      if(this.bindDataList[idx].printerList.length <= 0) this.bindDataList[idx].printerLoading = true;
      switch (row.waybillCode) {
        case 'LUBAN':
          // 抖音官方模板
          dyPrint.getPrinterList();
          setTimeout(() => {
            this.dyAlertTitle = dyPrint.dyWebsocket && dyPrint.printerObj.printerList && dyPrint.printerObj.printerList.length ? '' : dyPrint.printerObj.alertTitle;
            this.bindDataList[idx].printerList = dyPrint.printerObj.printerList || [];
            this.bindDataList[idx].printerLoading = false;
            if(this.dyAlertTitle !== '') {
              this.printerTipTitle = '未检测到抖音打印组件，因此无法获取打印机信息';
              this.visible = true;
            }
            this.tableData = [...this.tableData];
          }, 500);
          break;
        case 'KS':
          // 快手打印组件
          ksPrint.getPrinterList();
          setTimeout(() => {
            this.ksAlertTitle = ksPrint.ksWebsocket && ksPrint.printerObj.printerList && ksPrint.printerObj.printerList.length ? '' : ksPrint.printerObj.alertTitle;
            this.bindDataList[idx].printerList = ksPrint.printerObj.printerList || [];
            this.bindDataList[idx].printerLoading = false;
            if(this.ksAlertTitle !== '') {
              this.printerTipTitle = '未检测到快手打印组件，因此无法获取打印机信息';
              this.visible = true;
            }
            this.tableData = [...this.tableData];
          }, 500);
        break;
        case 'PDD':
          pddPrint.getPrinterList();
          setTimeout(() => {
            this.pddTitle = pddPrint.printerObj.alertTitle;
            this.bindDataList[idx].printerList = pddPrint.printerObj.printerList || [];
            this.bindDataList[idx].printerLoading = false;
            if(this.pddTitle !== '') {
              this.printerTipTitle = '未检测到拼多多打印组件，因此无法获取打印机信息';
              this.visible = true;
            }
            this.tableData = [...this.tableData];
          }, 500);
          break;
        case 'JD':
          jdPrint.getPrinterList();
          setTimeout(() => {
            this.jdTitle = jdPrint.printerObj.alertTitle;
            this.bindDataList[idx].printerList = jdPrint.printerObj.printerList || [];
            this.bindDataList[idx].printerLoading = false;
            if(!!this.jdTitle) {
              this.printerTipTitle = '未检测到京东打印组件，因此无法获取打印机信息';
              this.visible = true;
            }
            this.tableData = [...this.tableData];
          }, 500);
          break;
        case 'XIAOHS':
          xhsNewPrint.getPrinterList();
          setTimeout(() => {
            this.xhsTitleNew = xhsNewPrint.printerObj.alertTitle;
            this.bindDataList[idx].printerList = xhsNewPrint.printerObj.printerList || [];
            this.bindDataList[idx].printerLoading = false;
            if(!!this.xhsTitleNew) {
              this.printerTipTitle = '未检测到小红书新打印组件，因此无法获取打印机信息';
              this.visible = true;
            }
            this.tableData = [...this.tableData];
          }, 500);
          break;
        case 'WXSPH':
          await wxPrint.getPrinterList();
          this.wxAlertTitle = wxPrint.wxWebsocket && wxPrint.printerObj.printerList && wxPrint.printerObj.printerList.length ? '' : wxPrint.printerObj.alertTitle;
          this.bindDataList[idx].printerList = wxPrint.printerObj.printerList || [];
          this.bindDataList[idx].printerLoading = false;
          if(this.wxAlertTitle !== '') {
            this.printerTipTitle = '未检测到腾讯打印组件，因此无法获取打印机信息';
            this.visible = true;
          }
          this.tableData = [...this.tableData];
          break;
        case 'WXGYS':
          await wxPrint.getPrinterList();
          this.wxAlertTitle = wxPrint.wxWebsocket && wxPrint.printerObj.printerList && wxPrint.printerObj.printerList.length ? '' : wxPrint.printerObj.alertTitle;
          this.bindDataList[idx].printerList = wxPrint.printerObj.printerList || [];
          this.bindDataList[idx].printerLoading = false;
          if(this.wxAlertTitle !== '') {
            this.printerTipTitle = '未检测到腾讯打印组件，因此无法获取打印机信息';
            this.visible = true;
          }
          this.tableData = [...this.tableData];
          break;
        case 'DEWU':
          dwPrint.getPrinterList();
          setTimeout(() => {
            this.dwAlertTitle = dwPrint.dewuWebsocket && dwPrint.printerObj.printerList && dwPrint.printerObj.printerList.length ? '' : dwPrint.printerObj.alertTitle;
            this.bindDataList[idx].printerList = dwPrint.printerObj.printerList || [];
            this.bindDataList[idx].printerLoading = false;
            if(this.dwAlertTitle !== '') {
              this.printerTipTitle = '未检测到腾讯打印组件，因此无法获取打印机信息';
              this.visible = true;
            }
            this.tableData = [...this.tableData];
          }, 500);
          break;
        default:
          cnPrint.getPrinterList();
          setTimeout(() => {
            this.cnTitle = cnPrint.printerObj.alertTitle;
            this.bindDataList[idx].printerList = cnPrint.printerObj.printerList || [];
            this.bindDataList[idx].printerLoading = false;
            if(this.cnTitle !== '') {
              this.printerTipTitle = '未检测到菜鸟打印组件，因此无法获取打印机信息';
              this.visible = true;
            }
            this.tableData = [...this.tableData];
          }, 500);
          break;
      }
    },
    // 默认打印机设置
    handleChangePrint(val, row) {
      const params = {
        ...row,
        defaultPrint: val
      }
      updatePrintTplApi(params).then(() => {
        this.$message.success('默认打印机设置成功');
        this.tableData = [...this.tableData];
        // 备份数据需要同步更新，前端分页需要用到备份数据
        this.allTableList.forEach(item => {
          if (item.id == row.id) {
            row.defaultPrint = val;
          }
        })
        this.allTableListBak.forEach(item => {
          if (item.id == row.id) {
            row.defaultPrint = val;
          }
        })
      })
    },
    // 所有平台鉴权
    authenticationForAllPlatform() {
      // 菜鸟的鉴权在弹窗里面再做
      let state = this.$route.query.state;
      state =state?state.split('-'):state;
      if (this.$route.query && state !== '' && state !== null && state !== undefined) {
        if((state[0] + '') === '19' && state[2] == '1688'){
          let paramsAli = {
            userId: this.userMess.loginId,
            mallCode: state[4],
            cpCode: state[1],
            token: this.$route.query.accessToken,
            mallName: this.$route.query.mallName
          }
          this.aliBillAuth(paramsAli, state);
        } else if((state[0] + '') === '19'){
          // 淘宝鉴权
          let paramsTaobao = {
            mallCode: state[4],
            cpCode: state[1]
          }
          this.wayBillAuth(paramsTaobao,state);
        }else if((state[0] + '') === '3' && state[1] === 'dewu'){
          // 得物鉴权
          let paramsdewu = {
            code: this.$route.query.code,
            state: state[0]
          }
          this.mallCodeWayBillDewu(paramsdewu);
        } else if((state[0] + '') === '4' && state[1] === 'dyDaiFa'){
          // 鲁班厂商鉴权
          let paramsluban = {
            code: this.$route.query.code,
            state: state[0]
          }
          this.dydfMallCodeWayBill(paramsluban);
        } else if((state[0] + '') === '4' && state[1] === 'jd'){
          // 京东店铺鉴权
          let paramsJingdong = {
            code:this.$route.query.code,
            state:state[1]
          }
          this.mallCodeWayBillJD(paramsJingdong);
        } else if((state[0] + '') === '3' && state[1] === 'ks'){
          // 快手店铺鉴权
          let paramsJingdong = {
            code:this.$route.query.code,
            state:state[1]
          }
          this.mallCodeWayBillKS(paramsJingdong);
        } else if((state[0] + '') === '3' && state[1] === 'xiaohs'){
          // 小红书鉴权
          let paramsXiaohs = {
            code:this.$route.query.code,
            state:state[0]
          }
          this.mallCodeWayBillXiaoHS(paramsXiaohs,state[0]);
        } else if((state[0] + '') === '3' && state[1] === 'yz'){
          // 有赞鉴权
          let paramsYz = {
            code:this.$route.query.code,
            state:state[0]
          }
          this.mallCodeWayBillYz(paramsYz,state[0]);
        } else if ((state[0] + '') === '3') {
          if(this.$route.query.code){
            // PDD 鉴权
            let params = {
              code: this.$route.query.code,
              state: state[0]
            };
            this.pddAuthentication(params,state[1]);
          }
        } else if((state[0] + '') === '4'){
          // 抖音鉴权
          let paramsluban = {
            code:this.$route.query.code,
            state:state[0]
          }
          this.mallCodeWayBillLuban(paramsluban,state[1]);
        }
      }

      // 菜鸟鉴权
      if(this.$route.query.accessCode){
        this.initCNAccessToken();
      }
    },
    // 菜鸟接口返回成功后，初始化界面
    initCNAccessToken() {
      // 获取accesstoken and appkey
      getCaiNiaoGrantTokenApi({accesscode: this.$route.query.accessCode}).then((resp) => {
        if (resp.message === 'error') {
          this.$message.error(resp.error || '获取token发生错误');
        } else {
          this.getAllAccountEleInfo('CN', resp.data.grantName, resp.data.token);
          this.$router.replace({name: this.$route.name});// 授权成功后，页面重新加载，去掉url中的code 和state，避免多次弹授权成功层
          this.$message.success('授权成功！');
        }
      });
    },
    // 拼多多鉴权
    pddAuthentication(params) {
      pddMallCodeWayBillApi(params).then(res => {
        if (res.message === 'ok') {
          this.getAllAccountEleInfo('PDD', res.data.mallCode);
          this.$router.replace({name: this.$route.name});// 授权成功后，页面重新加载，去掉url中的code 和state，避免多次弹授权成功层
          this.$message.success('授权成功！');
        } else {
          this.$message.error(res.error);
        }
      }).catch(err => {
        this.$message.error(err.error);
      });
    },
    // 得物鉴权
    mallCodeWayBillDewu(params,state){
      mallCodeWayBillDewuApi(params).then(res => {
        if (res.message === 'ok') {
          this.getAllAccountEleInfo('DEWU', res.data.id);
          this.$router.replace({name: this.$route.name});// 授权成功后，页面重新加载，去掉url中的code 和state，避免多次弹授权成功层
          this.$nextTick(() => {
            this.$message({
              message: '授权成功！',
              type: 'success'
            });
          });
        } else {
          this.$message.error(res.error);
        }
      }).catch(err => {
        this.$message.error(err.error);
      });
    },
    // 抖音鉴权
    mallCodeWayBillLuban(params, state){
      mallCodeWayBillLubanApi(params).then(res => {
        if (res.message === 'ok') {
          this.getAllAccountEleInfo('LUBAN', res.data.id);
          this.$router.replace({name: this.$route.name});// 授权成功后，页面重新加载，去掉url中的code 和state，避免多次弹授权成功层
          this.$message.success('授权成功！');
        } else {
          this.$message.error(res.error);
        }
      }).catch(err => {
        this.$message.error(err.error);
      });
    },
    // 抖音厂商代发鉴权
    dydfMallCodeWayBill(params){
      dydfMallCodeWayBillApi(params).then(res => {
        if (res.message === 'ok') {
          this.getAllAccountEleInfo('DYDF', res.data.id);
          this.$router.replace({name: this.$route.name});// 授权成功后，页面重新加载，去掉url中的code 和state，避免多次弹授权成功层
          this.$message.success('授权成功！');
        } else {
          this.$message.error(res.error);
        }
      }).catch(err => {
        this.$message.error(err.error);
      });
    },
    // 淘宝店铺鉴权
    wayBillAuth(params,state) {
      wayBillISearchApi(params).then(res => {
        if (res.code === 1) {
          if(state){
            this.getAllAccountEleInfo('TAOBAO', params.mallCode);
            // 授权跳转后
            this.$router.replace({name: this.$route.name});// 授权成功后，页面重新加载，去掉url中的code 和state，避免多次弹授权成功层
            this.$message.success('授权成功！');
          }
        } else {
          this.$message.error(res.data || res.error);
        }
      }).catch(err => {
        this.$message.error(err.error);
      });
    },
    // 1688鉴权
    aliBillAuth(params, state) {
      aliBillSearchApi(params).then(res => {
        if (res.message === 'ok') {
          if(state){
            this.getAllAccountEleInfo('ALI_1688', params.mallCode, params.token, params.mallName);
            // 授权跳转后
            this.$router.replace({name: this.$route.name});// 授权成功后，页面重新加载，去掉url中的code 和state，避免多次弹授权成功层
            this.$message.success('授权成功！')
          }
        } else {
          this.$message.error(res.error || '获取数据失败');
        }
      }).catch(err => {
        this.$message.error(err.error || '网络异常，获取数据失败');
      });
    },
    // 京东鉴权
    mallCodeWayBillJD(params) {
      jdWaybillCodeAuthorizeApi(params).then(res => {
        if (res.message === 'ok') {
          this.getAllAccountEleInfo('JD', res.data.id, res.data.mallCode);
          this.$router.replace({name: this.$route.name});// 授权成功后，页面重新加载，去掉url中的code 和state，避免多次弹授权成功层
          this.$message.success('授权成功！');
        } else {
          this.$message.error(res.error || '授权失败');
        }
      }).catch(err => {
        this.$message.error(err.error || '授权失败');
      });
    },
    // 快手鉴权
    mallCodeWayBillKS(params) {
      mallCodeWayBillKsApi(params).then(res => {
        if (res.message === 'ok') {
          this.getAllAccountEleInfo('KS', res.data.id || '', res.data.mallCode || '');
          this.$router.replace({name: this.$route.name});// 授权成功后，页面重新加载，去掉url中的code 和state，避免多次弹授权成功层
          this.$message.success('授权成功！');
        } else {
          this.$message.error(res.error || '授权失败');
        }
      }).catch(err => {
        this.$message.error(err.error || '授权失败');
      });
    },
    // 小红书鉴权
    mallCodeWayBillXiaoHS(params) {
      xiaohsMallCodeWayBillApi(params).then(res => {
        if (res.message === 'ok') {
          this.getAllAccountEleInfo('XIAOHS', res.data.id || '', res.data.mallCode || '');
          this.$router.replace({name: 'ElectronicBillManagement'});// 授权成功后，页面重新加载，去掉url中的code 和state，避免多次弹授权成功层
          this.$nextTick(() => {
            this.$message({
              message: '授权成功！',
              type: 'success'
            });
          });
        } else {
          this.$message.error(res.error || '授权失败');
        }
      }).catch(err => {
        this.$message.error(err.error || '授权失败');
      });
    },
    // 有赞鉴权
    mallCodeWayBillYz(params) {
      yzMallCodeWayBillApi(params).then(res => {
        if (res.message === 'ok') {
          this.getAllAccountEleInfo('YZ', res.data.id || '', res.data.mallCode || '');
          this.$router.replace({name: 'ElectronicBillManagement'});// 授权成功后，页面重新加载，去掉url中的code 和state，避免多次弹授权成功层
          this.$nextTick(() => {
            this.$message({
              message: '授权成功！',
              type: 'success'
            });
          });
        } else {
          this.$message.error(res.error || '授权失败');
        }
      }).catch(err => {
        this.$message.error(err.error || '授权失败');
      });
    },
    // 自定义模板
    customTemplate(row) {
      if((row.waybillCode === 'WXSPH' || row.waybillCode === 'WXGYS') && !row.editable) {
        this.$message.error('腾讯电子面单暂不支持自定义模板');
        return;
      }
      if (this.threeTempType.includes(row.baseTempId)) {
        this.$confirm('三联单不支持自定义模板，请使用一联单或二联单', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
          closeOnClickModal: false
        }).then(() => {});
        return false;
      }
      if (util.yzdWaybillList.includes(row.baseTempId)) {
        this.$confirm('圆通标准面单已支持使用圆准达服务，打印时可以选择圆通标准模板', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          return false;
        });
        return false;
      }
      this.$router.push({name: 'CutomWaybillTemplateNew', params: row});
    },
    // 删除模板
    deleteTemplate(row) {
      this.$confirm('确认删除该模板吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除模板
        delUserCustomPrintTplApi([row.id], this.userMess.loginId).then(res => {
          if (res.message === 'ok') {
            // 同步删除历史FASTDFS文件
            this.deleteFastXmlFile(row);
            this.getUserPrintTempList();
            this.$nextTick(() => {
              this.$message({
                type: 'success',
                message: '操作成功！'
              });
            });
          } else {
            this.$message.error(res.error || '删除模板失败，请稍后再试！');
          }
        }).catch(err => {
          this.$message.error(err.error || '删除模板失败，请稍后再试！');
        });
      });
    },
    // 抖音&快手官方模板 - 删除FASTDFS文件
    deleteFastXmlFile(_data){
      if(this.dyksgfWaybillList.includes(_data.baseTempId) && ['LUBAN', 'KS', 'XIAOHS', 'WXSPH', 'WXGYS'].includes(_data.waybillCode) && _data.cpMarkPath){
        syncDeleteXmlFileApi({ filePath: _data.cpMarkPath || '' }).then(() => {}).catch(() => {});
      }
    },
    // 跳转地址维护页面
    addAddress() {
      this.addAddressDialog = true;
      const routerData = this.$router.resolve({
        path: '/systemSetting/addressMaintain'
      })
      window.open(routerData.href, '_blank');
    },
    refresh() {
      this.addAddressDialog = false;
      this.getSendAddressList();
    },
    // 鉴权成功后，将该店铺或账号下所有面单信息全部获取
    getAllAccountEleInfo(platformType, mallId, token, mallName) {
      let params = {};
      if (platformType === 'CN') {
        params = { platform: platformType, token, grantName: mallId};
      } else if (platformType === 'JD') {
        params = { platform: platformType, mallCode: token, mallId};
      } else if (platformType === 'KS') {
        params = { platform: platformType, mallCode: token, mallId};
      } else if(platformType == 'ALI_1688') {
        params = { platform: platformType, mallId, token, mallName };
      } else {
        params = { platform: platformType, mallId };
      }
      batchExpressBindApi(params).then(() => { });
    },
  },
  mounted() {
    // 激活一级菜单
    util.setActiveMenu('base');
    this.getSendAddressList(true);
    this.authenticationForAllPlatform();
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
};
</script>
<style lang="scss" scoped>
.y-w-115 {
  width: 115px;
}
.add-placeholder {
  color: #afafb7;
  line-height: 32px;
  font-size: 14px;
  padding-left: 20px;
  margin-top: 3px;
}
.add-address {
  text-decoration: none;
  line-height: 32px;
  font-size: 14px;
  padding-left: 20px;
}
/deep/ .add-address-dialog{
  width: 620px;
  .el-dialog__header{
    background: none;
  }
}
.pre-box {
  height: 72px;
  width: 72px;
  border: 1px solid #EBEEF5;
  margin: 0 auto;
}
.shoplist {
  max-height: 75px;
  overflow: auto;
  padding-right: 10px;
  .icon {
    height: 24px;
    width: 24px;
    vertical-align: middle;
  }
}
</style>
